export enum InventoryRuleRunType {
  Processed = "processed",
  Scheduled = "scheduled",
  Manual = "manual",
  Recurring = "recurring",
}
